import { AccessTokenPayloadT, TokenObjT } from 'types/shared/core/Token';
import { decodeToken } from 'react-jwt';
import interfaceBridge from './interfaceBridge';
class Token {
  static getAccessTokenPayload(token: string): AccessTokenPayloadT | null {
    const decoded = decodeToken<AccessTokenPayloadT>(token);
    if (decoded === null) return null;
    return decoded;
  }

  static getToken(kind: 'accessToken' | 'refreshToken') {
    const data = interfaceBridge.getData('CURRENT_USER_ID');
    const currentUserId = parseInt(data);
    if (!currentUserId) return '';

    const tokenObj: TokenObjT | null = interfaceBridge.loadToken(currentUserId);

    if (!tokenObj) return '';

    return tokenObj[kind];
  }

  static getCurrentUserId(): number | null {
    const data = interfaceBridge.getData('CURRENT_USER_ID');
    const currentUserId = parseInt(data);
    if (!currentUserId) return null;
    return currentUserId;
  }

  static getCurrentTeacherAcademyId(): number | null {
    const payload = Token.getAccessTokenPayload(Token.getToken('accessToken'));
    if (payload?.role !== 'teacher' || !payload.academyId) return null;
    return payload.academyId;
  }

  static setCurrentUserId(id: number) {
    interfaceBridge.setData('CURRENT_USER_ID', id.toString());
  }
}

export default Token;
